'use client';

import type { ReactElement } from 'react';
import { Badge } from '@/components/ui/badge';
import { SvgCart } from '../icons-eataly';
import { cn } from '@/lib/utils';

export default function CartBadgeIcon({ numberOfItems }: { numberOfItems: number }): ReactElement {
    // Always render the badge (including 0) so the header layout stays stable; never show a negative count.
    const displayCount = Math.max(0, numberOfItems);
    const isThreeDigits = displayCount > 99;
    return (
        <>
            <SvgCart className="size-6" aria-hidden data-testid="shopping-cart-icon" />
            <Badge
                hierarchy="secondary"
                aria-hidden
                className={cn(
                    'absolute top-[2px] left-[12xpx] label-s font-medium bg-transparent flex items-center justify-center text-[var(--brown-30)] [a&]:hover:opacity-100',
                    isThreeDigits && 'text-[7px]!'
                )}
                data-testid="shopping-cart-badge">
                {isThreeDigits ? '99+' : displayCount}
            </Badge>
        </>
    );
}
